import {Component, input, InputSignal, signal} from '@angular/core';

import {SvgSpriteIcon} from '../svg-sprite';
import {OutsideClickDirective} from '../directives';

@Component({
  selector: 'lib-popup-toggle',
  standalone: true,
  templateUrl: './popup-toggle.component.html',
  styleUrl: './popup-toggle.component.scss',
  host: {
    '(click)': 'onClick()',
  },
  imports: [
    OutsideClickDirective,
  ],
})
export class PopupToggleComponent {
  readonly icon: InputSignal<SvgSpriteIcon> = input.required<SvgSpriteIcon>();

  protected isShown = signal(false);

  onClick(): void {
    this.isShown.update(shown => !shown);
  }

  dismiss(): void {
    this.isShown.set(false);
  }
}
